
// PROFILE > MUTATIONS

export default {
  setProfile (state, profile) {
    state.profile = profile
  },
}